export default __webpack_public_path__ + "images/logo-hoffman.svg?5e5f993ce49ed1e0de56cf0f6ea1c86c";